import { React, useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/AppContext";
import DDlogo from "../../assets/images/DDlogo.png";
import DatePicker from "react-datepicker";
import DatePlus from "../../assets/images/Group 33597.svg";
import redCross from "../../assets/images/redCross.svg";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Select, Space, TimePicker } from "antd";
import ApiConfig from "../../api/ApiConfig";
import Form from "react-bootstrap/Form";
import { notifyError, notifySuccess } from "../../sharedComponent/notify";
import {
  postMultipartWithAuthCallWithErrorResponse,
  postMultipartWithAuthCallWithErrorResponseNodeCreate,
  postWithAuthCall,
  simpleGetCall,
  simplePostCall,
} from "../../api/ApiServices";
import moment from "moment";
import dayjs from "dayjs";
import Loader from "../../sharedComponent/Loader";
import { useTranslation } from "react-i18next";
import { Col, FormControl, Nav, Tab } from "react-bootstrap";

const { Option } = Select;

const DispatchSetting = () => {
  const {
    sidebar,
    setSidebar,
    Dark,
    setWeekenHide,
    dispatch_settings_cod_status,
    setDispatchSettingPaymentMode,
  } = useContext(AppContext);
  const customer_id = localStorage.getItem("customer_id");
  const [startDate, setStartDate] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [timeInput, setTimeInput] = useState("");
  const [rangeConvertFlag, setRangeConvertFlag] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [base_delivery_charge_error, set_base_delivery_charge_error] =
    useState("");
  const [inputValue, setInputValue] = useState("");
  const [inputFlag, setInputFlag] = useState(true);
  const { t, i18n } = useTranslation();
  const [categoryDataList, setCategoryDataList] = useState([]);

  const [dispatchSettings, setDispatchSettings] = useState({
    dispatch_periodical_trip_settings_time: [],
    deliveryCharge: 0,
    dispatch_vehicle_type:"",
    dispatch_driver_availability:"",
    dispatch_working_shift_start:"",
    dispatch_case_km:"",
    dispatch_working_shift_end:"",
    dispatch_vehicle_capacity:"",
    dispatch_vehicle_availability:"",
    dispatch_settings_auto_routing: "instant",
    dispatch_setting_km_range: 0,
    dispatch_good_capacity:0,
    dispatch_settings_cod_status: 0,
    dispatch_settings_minimum_order_price: 0,
    dispatch_settings_cancel_in_minutes: 0,
    dispatch_settings_default_loading_time_duration: "00:00:00",
    dispatch_settings_default_unloading_time_duration: "00:00:00",
    dispatch_setting_delivery_charge: 0,
    dispatch_setting_base_delivery_charges: 0,
    dispatch_setting_charges_km: 0,
    dispatch_setting_per_extra_km_charge: 0,
    dispatch_setting_exemption_order_amount: 0,
    dispatch_setting_charge_exemption: 0,
    settings_online_payment: 0,
    dispatch_settings_status_auto_update: false,
    dispatch_settings_cod_confi: {
      package_setting: { package_charges: 0, package_exemption_price: 0 },
      data: [
        { type: "Standard", cod: false, online: false },
        { type: "Express", cod: false, online: false },
      ],
      deliveryCharges: [{ price: 0, range_start: 0, range_end: 0 }],
    },
    // New fields for requirements
    dispatch_settings_vehicle_type: "owned", // owned or contract
    dispatch_settings_vehicle_capacity: 0, // in cubic meters or weight
    dispatch_settings_package_size_limit: 0, // max package size
    dispatch_settings_working_hours_start: "08:00",
    dispatch_settings_working_hours_end: "18:00",
    dispatch_settings_geofence_id: null, // Optional: link to transport geofence
  });

  const [currentTab, setCurrentTab] = useState("0");
  const [unit, setUnit] = useState(
    localStorage.getItem("customer_distance_unit") || "km"
  );


    const automaticDataCategory = (data) => {
    let newData = categoryDataList?.filter(
      (ele) => ele.vehicle_type_id == data
    );
    setDispatchSettings({
      ...dispatchSettings,
      dispatch_vehicle_type: newData[0].vehicle_type_id,
    
       
    });
  };

  const aninations = {
    initial: { opacity: 0, x: 400 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 100 },
  };
  const [exitNew, setExitNew] = useState("Exisiting");

  useEffect(() => {
    getDispatchSettings(); 
    getCategoryList()
  }, []);

  const timeToMinutes = (time) => {
    const [hours, minutes, seconds] = time?.split(":")?.map(Number);
    return hours * 60 + minutes + Math.floor(seconds / 60);
  };

  const kmToMiles = (km) => km * 0.621371;
  const milesToKm = (miles) => miles / 0.621371;
  const getCategoryList = () => {
    simplePostCall(
      ApiConfig.VEHICLE_DROWPDOWN,
      JSON.stringify({
        key: "VehicleCategory",
      })
    )
      .then((res) => {
        setCategoryDataList(res?.data);
      })
      .catch((error) => {
        console.log("api response", error);
      });
  };
  const getDispatchSettings = () => {
    setLoading(true);
    setRangeConvertFlag(false);
    simpleGetCall(ApiConfig.GET_DISPACH_SETTINGS)
      .then((res) => {
        let data = { ...res.data };
        data.dispatch_periodical_trip_settings_time =
          data.dispatch_periodical_trip_settings_time.map((item) => {
            let splitTime =
              item.dispatch_periodical_trip_settings_time.split(":");
            let hours = splitTime && splitTime[0];
            let minutes = splitTime && splitTime[1];
            return `${hours}:${minutes}`;
          });
        if (res.result) {
          setDispatchSettings({ ...dispatchSettings, ...data });
          localStorage.setItem(
            "dispatch_settings_default_loading_time_duration",
            timeToMinutes(
              res?.data?.dispatch_settings_default_loading_time_duration
            )
          );
          localStorage.setItem(
            "dispatch_settings_default_unloading_time_duration",
            timeToMinutes(
              res?.data?.dispatch_settings_default_unloading_time_duration
            )
          );
        }
      })
      .catch((err) => {
        notifyError(err);
      })
      .finally(() => {
        setLoading(false);
        setRangeConvertFlag(true);
      });
  };

  const preprocessDispatchSettings = (settings) => {
    const isMiles = localStorage.getItem("customer_distance_unit") === "miles";
    return {
      ...settings,
      dispatch_setting_km_range: isMiles
        ? Math.floor(milesToKm(settings.dispatch_setting_km_range))
        : Math.floor(settings.dispatch_setting_km_range),
      dispatch_settings_vehicle_capacity: parseFloat(
        settings.dispatch_settings_vehicle_capacity
      ),
      dispatch_settings_package_size_limit: parseFloat(
        settings.dispatch_settings_package_size_limit
      ),
    };
  };

  const submitData = () => {
    if (
      !dispatchSettings.dispatch_setting_base_delivery_charges &&
      dispatchSettings.dispatch_setting_delivery_charge
    ) {
      set_base_delivery_charge_error("Enter base delivery charge");
      return;
    }
    if (
      dispatchSettings.dispatch_settings_auto_routing === "periodically" &&
      dispatchSettings.dispatch_periodical_trip_settings_time.length === 0
    ) {
      notifyError("Please Add Periodic Trip Times");
      return;
    }
    const body = JSON.stringify(preprocessDispatchSettings(dispatchSettings));
    setLoading(true);
    simplePostCall(ApiConfig.UPDATE_DISPATCH_SETTING, body)
      .then((res) => {
        if (res.result) {
          notifySuccess(res.message);
          localStorage.setItem(
            "dispatch_settings_cod_status",
            dispatchSettings.dispatch_settings_cod_status
          );
          setDispatchSettingPaymentMode(
            dispatchSettings.dispatch_settings_cod_status
          );
          getDispatchSettings();
        } else {
          notifyError(res?.error);
        }
      })
      .catch((err) => {
        notifyError(err.message);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (inputFlag) {
      if (localStorage.getItem("customer_distance_unit") === "miles") {
        setInputValue(
          kmToMiles(dispatchSettings?.dispatch_setting_km_range || "")
        );
      } else {
        setInputValue(dispatchSettings?.dispatch_setting_km_range || "");
      }
    }
  }, [dispatchSettings, inputFlag]);

  const handleConfiqChange = (index, mainField, field, value) => {
    setDispatchSettings((prev) => {
      const updatedCODConf = [...prev.dispatch_settings_cod_confi[mainField]];
      updatedCODConf[index] = {
        ...updatedCODConf[index],
        [field]: value,
      };
      return {
        ...prev,
        dispatch_settings_cod_confi: {
          ...prev.dispatch_settings_cod_confi,
          [mainField]: updatedCODConf,
        },
      };
    });
  };

  const handlePackageSettingChange = (field, value) => {
    setDispatchSettings((prev) => ({
      ...prev,
      dispatch_settings_cod_confi: {
        ...prev.dispatch_settings_cod_confi,
        package_setting: {
          ...prev.dispatch_settings_cod_confi.package_setting,
          [field]: value,
        },
      },
    }));
  };







    const handleChange = (event) => {
    const { name, value } = event.target;
    const addVehicleDatacopy = { ...dispatchSettings };
    addVehicleDatacopy[name] = value;
    setDispatchSettings(addVehicleDatacopy);

  };
  return (
    <motion.div
      className={sidebar ? "taskMain" : "cx-active taskMain"}
      id="cx-main"
      variants={aninations}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.1 }}
    >
      <div id="cx-wrapper" className="Dispatch_Setting">
        {loading ? (
          <Loader />
        ) : (
          <div className="main-master-wrapper mb-0 inner-tabs-section tabs-custom-width-33">
            <Tab.Container
              id="left-tabs-example"
              className="td-tab-wrapper"
              defaultActiveKey="0"
            >
              <Nav
                variant="pills"
                className="td-nav"
                onSelect={(selectedKey) => setCurrentTab(`${selectedKey}`)}
              >
                <Nav.Item className="td-tab">
                  <Nav.Link className="td-link" eventKey="0">
                    {t("Geography")}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="td-tab">
                  <Nav.Link className="td-link" eventKey="1">
                    {t("Vehicle/Driver")}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="td-tab">
                  <Nav.Link className="td-link" eventKey="2">
                    {t("Time & Cost")}
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              <Col sm={12} className="">
                <Tab.Content>
                  {/* Geography Tab */}
                  <Tab.Pane eventKey="0">
                    <div className="all-vehicle-main mt-10">
                      <div
                        className="innerSelectBox weekCounter"
                        style={{
                          marginTop: "20px",
                        }}
                      >
                        <Form.Label className="common-labels">
                          {t("Geofence (Optional)")}
                        </Form.Label>
                        <Select
                          style={{ width: "100%", height: "40px" }}
                          value={
                          "Transportation Geofence"
                          }
                          onChange={(value) =>
                            setDispatchSettings({
                              ...dispatchSettings,
                              dispatch_settings_geofence_id:
                                value === "Transportation Geofence" ? null : value,
                            })
                          }
                        >
                          <Option value="default">
                            {t("Use Transport Geofence")}
                          </Option>
                          {/* Add API call to fetch geofences if available */}
                          <Option value="
Transportation Geofence">Transportation Geofence</Option>
                        
                        </Select>
   <Form.Label className="common-labels mt-3">
                          Goods Capacity 
                          <span>*</span>
                        </Form.Label>
                        <Form.Control
                          required
                          type="number"
                          min={0}
                          placeholder=" Goods Capacity ..."
                          value={
                            dispatchSettings.dispatch_good_capacity
                          }
                          onChange={(e) => {
                            const value = e.target.value;
                            // setInputFlag(false);
                            // setInputValue(value);
                            setDispatchSettings({
                              ...dispatchSettings,
                              dispatch_good_capacity: value,
                            });
                          }}
                        />
                        <Form.Label className="common-labels mt-3">
                          {localStorage.getItem("customer_distance_unit") ===
                          "km"
                            ? "Maximum Deliverable Distance (KM)"
                            : "Maximum Deliverable Distance (Miles)"}{" "}
                          <span>*</span>
                        </Form.Label>
                        <Form.Control
                          required
                          type="number"
                          min={0}
                          placeholder="Enter Distance..."
                          value={
                            inputValue ? Math.floor(inputValue) : inputValue
                          }
                          onChange={(e) => {
                            const value = e.target.value;
                            setInputFlag(false);
                            setInputValue(value);
                            setDispatchSettings({
                              ...dispatchSettings,
                              dispatch_setting_km_range: value,
                            });
                          }}
                        /> 


                        

                        <Form.Label className="common-labels mt-3">
                          {t("Base Delivery Charge / Km")} <span>*</span>
                        </Form.Label>
                        <Form.Control
                          required
                          type="number"
                          min={0}
                          placeholder={t("Enter Base Delivery Charge/KM...")}
                          value={
                            dispatchSettings?.dispatch_setting_charges_km || ""
                          }
                          onChange={(e) =>
                            setDispatchSettings({
                              ...dispatchSettings,
                              dispatch_setting_charges_km: e.target.value,
                            })
                          }
                        />

                        <Form.Label className="common-labels mt-3">
                          {t("Per Extra Km / Charge")} <span>*</span>
                        </Form.Label>
                        <Form.Control
                          required
                          type="number"
                          min={0}
                          placeholder={t("Enter Per Extra Km Charge...")}
                          value={
                            dispatchSettings?.dispatch_setting_per_extra_km_charge ||
                            ""
                          }
                          onChange={(e) =>
                            setDispatchSettings({
                              ...dispatchSettings,
                              dispatch_setting_per_extra_km_charge:
                                e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                  </Tab.Pane>

                  {/* Vehicle/Driver Tab */}
                  <Tab.Pane eventKey="1">
                    <div className="all-vehicle-main">
                      <div
                        className="innerSelectBox weekCounter"
                        style={{
                          marginTop: "20px",
                        }}
                      >
                        {/* <Form.Label className="common-labels">
                          {t("Vehicle Type")}
                        </Form.Label>
                        <Select
                          style={{ width: "100%", height: "40px" }}
                          value={
                            dispatchSettings.dispatch_settings_vehicle_type
                          }
                          onChange={(value) =>
                            setDispatchSettings({
                              ...dispatchSettings,
                              dispatch_settings_vehicle_type: value,
                            })
                          }
                        >
                          <Option value="owned">{t("Owned")}</Option>
                          <Option value="contract">{t("Contract")}</Option>
                        </Select>  */}

  <div className="form_input_main">
                      <div className="d-flex justify-content-between flex-wrap">
                        <Form.Label className="common-labels label-with-radio custom-label-title form_input_main me-0">
                          <p>
                            {t("Vehicle Type")} <span>&#42;</span>
                          </p>
                        </Form.Label>

                        <div id="customRadios">
                          <div class="form-check greenFlex me-2">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="flexRadioDefault2"
                              id="Exisiting"
                              checked={exitNew === "Exisiting" ? true : false}

                              onChange={(e) => {
                                setExitNew("Exisiting");
                                setDispatchSettings({
                                  ...dispatchSettings,
                                  dispatch_vehicle_type: "",
                                });
                              }}
                            />
                            <label
                              class="form-check-label custLabel"
                              for="Exisiting"
                            >
                              {t("Existing")}
                            </label>
                          </div>
                          <div class="form-check  greenFlex">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="flexRadioDefault2"
                              id="New"
                              checked={exitNew === "New" ? true : false}
                              onChange={(e) => {
                                setExitNew("New");
                                setDispatchSettings({
                                  ...dispatchSettings,
                                  dispatch_vehicle_type: "",
                                });
                              }}
                            />
                            <label class="form-check-label custLabel" for="New">
                              {t("New")}
                            </label>
                          </div>
                        </div>
                      </div>
                      {exitNew === "Exisiting" && (
                        <div className="multi-select-1">
                          <Select
                            style={{
                              width: "100%",
                              height: "40px",
                              color: "rgba(156, 73, 0, 0.5)",
                            }}
                            showSearch
                            value={dispatchSettings?.dispatch_vehicle_type}
                            onChange={(value) => {
                             
                              automaticDataCategory(value);
                            }}
                            className="custom-select"
                            placeholder={t("Select Vehicle Type...")}
                          >
                            <Option
                              style={{ color: "rgb(156, 73, 0)" }}
                              key={"1"}
                            >
                              {t("Select Vehicle Type...")}
                            </Option>
                            {categoryDataList && categoryDataList?.length > 0
                              ? categoryDataList?.map((item, index) => {
                                return (
                                  <Option
                                    key={"dispatch_vehicle_type" + index}
                                    style={{ color: "rgb(156, 73, 0)" }}
                                    value={item?.vehicle_type_id}
                                  >
                                    {item.vehicle_type_code}
                                  </Option>
                                );
                              })
                              : "no data available"}
                          </Select>
                        </div>
                      )}

                      {exitNew === "New" && (
                        <Form.Control
                          required
                          type="text"
                          placeholder={t("Enter vehicle Type..")}
                          name="dispatch_vehicle_type"
                          value={dispatchSettings.dispatch_vehicle_type}
                          onChange={handleChange}
                        />
                      )}
                      
                    </div>








                        <Form.Label className="common-labels mt-10">
                          {t("Driver Availability ")}
                        </Form.Label>
                        <Select
                          style={{ width: "100%", height: "40px" }}
                          value={
                            dispatchSettings.dispatch_driver_availability
                          }
                          onChange={(value) =>
                            setDispatchSettings({
                              ...dispatchSettings,
                              dispatch_driver_availability: value,
                            })
                          }
                        >
                          <Option value="Completed">{t("Completed")}</Option>
                          <Option value="Busy">{t("Busy")}</Option>
                        </Select>

                        <Form.Label className="common-labels mt-10">
                          {t("Vehicle Availability")}
                        </Form.Label>
                        <Select
                          style={{ width: "100%", height: "40px" }}
                          value={
                            dispatchSettings.dispatch_vehicle_availability
                          }
                          onChange={(value) =>
                            setDispatchSettings({
                              ...dispatchSettings,
                              dispatch_vehicle_availability: value,
                            })
                          }
                        >
                          <Option value="Trip / Scheduled">{t("Trip / Scheduled")}</Option>
                          <Option value="Instant Trip">{t("Instant Trip")}</Option>
                          <Option value="dispatched">{t("dispatched")}</Option>
                          <Option value="Completed">{t("Completed")}</Option>
                       
                        </Select>

                        <Form.Label className="common-labels mt-3">
                          {t("Vehicle Capacity")} <span>*</span>
                        </Form.Label>
                        <Form.Control
                          required
                          type="number"
                          min={0}
                          placeholder={t("Enter Vehicle Capacity...")}
                          value={
                            dispatchSettings?.dispatch_vehicle_capacity ||
                            ""
                          }
                          onChange={(e) =>
                            setDispatchSettings({
                              ...dispatchSettings,
                              dispatch_vehicle_capacity:
                                e.target.value,
                            })
                          }
                        />

                        <Form.Label className="common-labels mt-3">
                          {t("Maximum Package Size (Cubic Meters)")}{" "}
                          <span>*</span>
                        </Form.Label>
                        <Form.Control
                          required
                          type="number"
                          min={0}
                          placeholder={t("Enter Maximum Package Size...")}
                          value={
                            dispatchSettings?.dispatch_settings_package_size_limit ||
                            ""
                          }
                          onChange={(e) =>
                            setDispatchSettings({
                              ...dispatchSettings,
                              dispatch_settings_package_size_limit:
                                e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                  </Tab.Pane>

                  {/* Time & Cost Tab */}
                  <Tab.Pane
                    eventKey="2"
                    style={{
                      marginTop: "20px",
                    }}
                  >
                    <div className="all-vehicle-main">
                      <div className="innerSelectBox weekCounter">
                        {/* Dispatch Auto-routing Type */}
                        <Form.Label className="common-labels">
                          {t("Dispatch Auto-routing Type")}
                        </Form.Label>
                        <Select
                          style={{ width: "100%", height: "40px" }}
                          required
                          value={
                            dispatchSettings.dispatch_settings_auto_routing
                          }
                          onChange={(value) =>
                            setDispatchSettings({
                              ...dispatchSettings,
                              dispatch_settings_auto_routing: value,
                            })
                          }
                        >
                          <Option value="instant">{t("Instant")}</Option>
                          <Option value="periodically">
                            {t("Periodically")}
                          </Option>
                          <Option value="manual">{t("Manual")}</Option>
                        </Select>

                        {/* Periodic Trip Times */}
                        {dispatchSettings.dispatch_settings_auto_routing ===
                          "periodically" && (
                          <div className="row align-items-end">
                            {/* Time input */}
                            <div className="col-md-7">
                              <div className="innerSelectBox weekCounter">
                                <label className="common-labels">
                                  {t("Periodic Trip Times")} <span>&#42;</span>
                                </label>

                                <Space style={{ width: "100%" }}>
                                  <TimePicker
                                    className="form-control carretClass"
                                    size="large"
                                    style={{ width: "100%" }}
                                    value={
                                      timeInput
                                        ? dayjs(timeInput, "HH:mm")
                                        : dayjs("00:00", "HH:mm")
                                    }
                                    onChange={(e) => {
                                      let time = e
                                        ? `${e.hour()}:${e.minute()}`
                                        : "00:00";
                                      setTimeInput(time);
                                      setErrorMsg("");
                                    }}
                                    format={"HH:mm"}
                                  />
                                </Space>

                                {errorMsg && (
                                  <div style={{ color: "red" }}>{errorMsg}</div>
                                )}
                              </div>
                            </div>

                            {/* Add button */}
                            <div className="col-md-2 weekCounter">
                              <button
                                className="AddOnBtn w-100"
                                onClick={() => {
                                  if (!timeInput) {
                                    setErrorMsg(
                                      "Please enter a periodic trip time"
                                    );
                                  } else {
                                    const timeArray = [
                                      ...dispatchSettings.dispatch_periodical_trip_settings_time,
                                    ];

                                    setDispatchSettings({
                                      ...dispatchSettings,
                                      dispatch_periodical_trip_settings_time: [
                                        ...timeArray,
                                        timeInput,
                                      ],
                                    });

                                    setTimeInput("");
                                  }
                                }}
                              >
                                {t("Add")}
                              </button>
                            </div>
                          </div>
                        )}

                        {/* Working Hours */}
                        

                               <Form.Label className="common-labels mt-3">
                          {t("Working Hours Start")}
                        </Form.Label>
                        <TimePicker
                          className="form-control carretClass"
                          size="large"
                          value={
                            dispatchSettings.dispatch_working_shift_start
                              ? dayjs(
                                  dispatchSettings.dispatch_working_shift_start,
                                  "HH:mm"
                                )
                              : dayjs("08:00", "HH:mm")
                          }
                          onChange={(e) => {
                            let time = e ? e.format("HH:mm") : "08:00";
                            setDispatchSettings({
                              ...dispatchSettings,
                              dispatch_working_shift_start: time,
                            });
                          }}
                          format={"HH:mm"}
                        />



                        <Form.Label className="common-labels mt-3">
                          {t("Working Hours End")}
                        </Form.Label>
                        <TimePicker
                          className="form-control carretClass"
                          size="large"
                          value={
                            dispatchSettings.dispatch_settings_working_hours_end
                              ? dayjs(
                                  dispatchSettings.dispatch_settings_working_hours_end,
                                  "HH:mm"
                                )
                              : dayjs("18:00", "HH:mm")
                          }
                          onChange={(e) => {
                            let time = e ? e.format("HH:mm") : "18:00";
                            setDispatchSettings({
                              ...dispatchSettings,
                              dispatch_settings_working_hours_end: time,
                            });
                          }}
                          format={"HH:mm"}
                        />
<Form.Label className="common-labels mt-3">
                          {t("Case Km")}
                        </Form.Label>
                          <Form.Control
                          required
                          type="number"
                          min={0}
                          placeholder={t("Dispatch case km...")}
                          value={
                            dispatchSettings?.dispatch_case_km ||
                            ""
                          }
                          onChange={(e) =>
                            setDispatchSettings({
                              ...dispatchSettings,
                              dispatch_case_km:
                                e.target.value,
                            })
                          }
                        />
                        {/* Default Load/Unload Duration */}
                        <Form.Label className="common-labels mt-3">
                          {t("Default Load Duration")}
                        </Form.Label>
                        <TimePicker
                          className="form-control carretClass"
                          size="large"
                          value={
                            dispatchSettings.dispatch_settings_default_loading_time_duration
                              ? dayjs(
                                  dispatchSettings.dispatch_settings_default_loading_time_duration,
                                  "HH:mm:ss"
                                )
                              : dayjs("00:00:00", "HH:mm:ss")
                          }
                          onChange={(e) => {
                            let time = e ? e.format("HH:mm:ss") : "00:00:00";
                            setDispatchSettings({
                              ...dispatchSettings,
                              dispatch_settings_default_loading_time_duration:
                                time,
                            });
                            setErrorMsg("");
                          }}
                          format={"HH:mm:ss"}
                        />

                        <Form.Label className="common-labels mt-3">
                          {t("Default Unload Duration")}
                        </Form.Label>
                        <TimePicker
                          className="form-control carretClass"
                          size="large"
                          value={
                            dispatchSettings.dispatch_settings_default_unloading_time_duration
                              ? dayjs(
                                  dispatchSettings.dispatch_settings_default_unloading_time_duration,
                                  "HH:mm:ss"
                                )
                              : dayjs("00:00:00", "HH:mm:ss")
                          }
                          onChange={(e) => {
                            let time = e ? e.format("HH:mm:ss") : "00:00:00";
                            setDispatchSettings({
                              ...dispatchSettings,
                              dispatch_settings_default_unloading_time_duration:
                                time,
                            });
                            setErrorMsg("");
                          }}
                          format={"HH:mm:ss"}
                        />

                        {/* Minimum Order Price */}
                        <Form.Label className="common-labels mt-3">
                          {t("Minimum Order Price")}
                        </Form.Label>
                        <Form.Control
                          required
                          type="number"
                          min={0}
                          placeholder={t("Enter Minimum Order Price...")}
                          value={
                            dispatchSettings?.dispatch_settings_minimum_order_price ||
                            ""
                          }
                          onChange={(e) =>
                            setDispatchSettings({
                              ...dispatchSettings,
                              dispatch_settings_minimum_order_price:
                                e.target.value,
                            })
                          }
                        />

                        {/* Order Cancellation Minutes */}
                        <Form.Label className="common-labels mt-3">
                          {t("Order Cancellation Minutes")}
                        </Form.Label>
                        <Form.Control
                          required
                          type="number"
                          min={0}
                          placeholder={t("Enter Order Cancellation Minutes...")}
                          value={
                            dispatchSettings?.dispatch_settings_cancel_in_minutes ||
                            ""
                          }
                          onChange={(e) =>
                            setDispatchSettings({
                              ...dispatchSettings,
                              dispatch_settings_cancel_in_minutes:
                                e.target.value,
                            })
                          }
                        />

                        {/* Delivery Charge Toggle */}
                        <div className="form-check form-switch mt-4">
                          <div className="d-flex innerFlexTog">
                            <label
                              className="form-check-label toggleLabel"
                              style={{ fontSize: "15px" }}
                            >
                              {t("Delivery Charge")}
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              style={{
                                marginLeft: "20px",
                              }}
                              checked={
                                dispatchSettings?.dispatch_setting_delivery_charge
                              }
                              onChange={(e) =>
                                setDispatchSettings({
                                  ...dispatchSettings,
                                  dispatch_setting_delivery_charge: e.target
                                    .checked
                                    ? 1
                                    : 0,
                                })
                              }
                            />
                          </div>
                        </div>

                        {dispatchSettings?.dispatch_setting_delivery_charge ===
                          1 && (
                          <>
                            <Form.Label className="common-labels mt-3">
                              {t("Base Delivery Charge")} <span>*</span>
                            </Form.Label>
                            <Form.Control
                              required
                              type="number"
                              min={0}
                              placeholder={t("Enter Base Delivery Charge...")}
                              value={
                                dispatchSettings?.dispatch_setting_base_delivery_charges ||
                                ""
                              }
                              onChange={(e) =>
                                setDispatchSettings({
                                  ...dispatchSettings,
                                  dispatch_setting_base_delivery_charges:
                                    e.target.value,
                                })
                              }
                            />
                            {base_delivery_charge_error && (
                              <div style={{ color: "red" }}>
                                {base_delivery_charge_error}
                              </div>
                            )}

                            <Form.Label className="common-labels mt-3">
                              {t("Exemption Order Amount")} <span>*</span>
                            </Form.Label>
                            <Form.Control
                              required
                              type="number"
                              min={0}
                              placeholder={t("Exemption Order Amount...")}
                              value={
                                dispatchSettings?.dispatch_setting_exemption_order_amount ||
                                ""
                              }
                              onChange={(e) =>
                                setDispatchSettings({
                                  ...dispatchSettings,
                                  dispatch_setting_exemption_order_amount:
                                    e.target.value,
                                })
                              }
                            />

                            <div className="form-check form-switch mt-4">
                              <div className="d-flex innerFlexTog">
                                <label className="form-check-label toggleLabel">
                                  {t("Exemption Charge")}
                                </label>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={
                                    dispatchSettings?.dispatch_setting_charge_exemption
                                  }
                                  onChange={(e) =>
                                    setDispatchSettings({
                                      ...dispatchSettings,
                                      dispatch_setting_charge_exemption: e
                                        .target.checked
                                        ? 1
                                        : 0,
                                    })
                                  }
                                />
                              </div>
                            </div>
                          </>
                        )}

                        {/* Payment Mode */}
                        <div className="form-check form-switch mt-4">
                          <p className="dispatchHead form_input_main">
                            {t("Payment Mode")}
                          </p>
                          <div className="d-flex gap-2">
                            <div className="d-flex innerFlexTog">
                              <label
                                className="form-check-label toggleLabel"
                                style={{ fontSize: "16px" }}
                              >
                                {t("Cash On Delivery (COD)")}
                              </label>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                style={{
                                  marginLeft: "250px",
                                }}
                                checked={
                                  dispatchSettings.dispatch_settings_cod_status
                                }
                                onChange={(e) =>
                                  setDispatchSettings({
                                    ...dispatchSettings,
                                    dispatch_settings_cod_status: e.target
                                      .checked
                                      ? 1
                                      : 0,
                                  })
                                }
                              />
                            </div>
                            <div className="d-flex innerFlexTog">
                              <label
                                className="form-check-label toggleLabel"
                                style={{ fontSize: "16px" }}
                              >
                                {t("Online")}
                              </label>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={
                                  dispatchSettings?.settings_online_payment
                                }
                                onChange={(e) =>
                                  setDispatchSettings({
                                    ...dispatchSettings,
                                    settings_online_payment: e.target.checked
                                      ? 1
                                      : 0,
                                  })
                                }
                              />
                            </div>
                          </div>
                        </div>

                        {/* Package Settings */}
                        <div className="form-check form-switch mt-4">
                          <p className="dispatchHead form_input_main">
                            {t("Package Setting")}
                          </p>
                        </div>
                        <div className="row">
                          <div className="col-md-6 form_input_main">
                            <Form.Label className="common-labels">
                              {t("Package Charge")} <span>*</span>
                            </Form.Label>
                            <Form.Control
                              required
                              type="number"
                              min={0}
                              placeholder={t("Enter Package Charge...")}
                              value={
                                dispatchSettings?.dispatch_settings_cod_confi
                                  ?.package_setting?.package_charges || ""
                              }
                              onChange={(e) =>
                                handlePackageSettingChange(
                                  "package_charges",
                                  e.target.value
                                )
                              }
                            />
                          </div>
                          <div className="col-md-6 form_input_main">
                            <Form.Label className="common-labels">
                              {t("Package Exemption Charge")} <span>*</span>
                            </Form.Label>
                            <Form.Control
                              required
                              type="number"
                              min={0}
                              placeholder={t("Package Exemption Charge...")}
                              value={
                                dispatchSettings?.dispatch_settings_cod_confi
                                  ?.package_setting?.package_exemption_price ||
                                ""
                              }
                              onChange={(e) =>
                                handlePackageSettingChange(
                                  "package_exemption_price",
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>

                        {/* Delivery Mode */}
                        <div className="form-check form-switch mt-4">
                          <p className="dispatchHead form_input_main">
                            {t("Delivery Mode")}
                          </p>
                        </div>
                        {dispatchSettings?.dispatch_settings_cod_confi?.data?.map(
                          (sett, index) => (
                            <div className="form-check form-switch" key={index}>
                              <p className="dispatchHead form_input_main">
                                {sett?.type}
                              </p>
                              <div className="d-flex gap-2">
                                <div className="d-flex innerFlexTog">
                                  <label
                                    className="form-check-label toggleLabel"
                                    style={{ fontSize: "16px" }}
                                  >
                                    {t("Cash On Delivery (COD)")}
                                  </label>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    style={{
                                      marginLeft: "20px",
                                    }}
                                    checked={sett?.cod}
                                    onChange={(e) =>
                                      handleConfiqChange(
                                        index,
                                        "data",
                                        "cod",
                                        e.target.checked
                                      )
                                    }
                                  />
                                </div>
                                <div className="d-flex innerFlexTog">
                                  <label
                                    className="form-check-label toggleLabel"
                                    style={{ fontSize: "16px" }}
                                  >
                                    {t("Online")}
                                  </label>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    style={{
                                      marginLeft: "20px",
                                    }}
                                    checked={sett?.online}
                                    onChange={(e) =>
                                      handleConfiqChange(
                                        index,
                                        "data",
                                        "online",
                                        e.target.checked
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          )
                        )}

                        {/* Delivery Charges */}
                        <div className="form-check form-switch mt-4">
                          <p className="dispatchHead form_input_main">
                            {t("Delivery Charges (In Km)")}
                          </p>
                        </div>
                        <div className="row ml-2">
                          <div className="form-check form-switch col-md-3">
                            <p className="dispatchHead form_input_main">
                              {t("Price")}
                            </p>
                          </div>
                          <div className="form-check form-switch col-md-3">
                            <p className="dispatchHead form_input_main">
                              {t("Range Start")}
                            </p>
                          </div>
                          <div className="form-check form-switch col-md-3">
                            <p className="dispatchHead form_input_main">
                              {t("Range End")}
                            </p>
                          </div>
                        </div>
                        {dispatchSettings?.dispatch_settings_cod_confi?.deliveryCharges?.map(
                          (charge, index) => (
                            <div className="row ml-2" key={index}>
                              <div className="form-check form-switch col-md-3">
                                <Form.Control
                                  required
                                  type="number"
                                  min={0}
                                  placeholder={t("Enter Price")}
                                  value={charge?.price || ""}
                                  onChange={(e) =>
                                    handleConfiqChange(
                                      index,
                                      "deliveryCharges",
                                      "price",
                                      e.target.value
                                    )
                                  }
                                />
                              </div>
                              <div className="form-check form-switch col-md-3">
                                <Form.Control
                                  required
                                  type="number"
                                  min={0}
                                  placeholder={t("Enter Start Range")}
                                  value={charge?.range_start || ""}
                                  onChange={(e) =>
                                    handleConfiqChange(
                                      index,
                                      "deliveryCharges",
                                      "range_start",
                                      e.target.value
                                    )
                                  }
                                />
                              </div>
                              <div className="form-check form-switch col-md-3">
                                <Form.Control
                                  required
                                  type="number"
                                  min={0}
                                  placeholder={t("Enter End Range")}
                                  value={charge?.range_end || ""}
                                  onChange={(e) =>
                                    handleConfiqChange(
                                      index,
                                      "deliveryCharges",
                                      "range_end",
                                      e.target.value
                                    )
                                  }
                                />
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Tab.Container>

            <div className="d-flex justify-content-end align-items-center btn-wrapper">
              <button className="cx-btn-2" onClick={submitData}>
                {t("Submit")}
              </button>
            </div>
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default DispatchSetting;
